import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateParent } from '../../../lib/modal';
import { asyncActions } from '../../../actions/general';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { getOrderMessages } from '../../../actions/shopping_carts';
import Support from '../../shared/Support';
import Error from '../../shared/Error';
import useSession from '../../../hooks/useSession';
import { supportPhone } from '../../../constants/SiteVariables';
import ReturnToMerchant from '../../shared/ReturnToMerchant';

export default function OrderFail({ location }) {
  const [session, sessionActions] = useSession();
  const dispatch = useDispatch();

  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');

  const [orderMessages, setOrderMessages] = useState([]);

  useRouteStatus(location);

  useEffect(() => {
    if (cart) {
      dispatch(asyncActions(getOrderMessages(cart))).then((res) =>
        setOrderMessages(res.attributes.data)
      );
    }

    sessionActions.finish();
  }, []);

  const redirect = () => {
    if (session.mode === 'modal') {
      updateParent('complete', cart ? cart.cancel_url : '');
    } else {
      if (
        cart &&
        cart.cancel_url &&
        session.session_type === 'standalone' &&
        session.strategy !== 'async'
      ) {
        window.location.href = cart.cancel_url;
      } else if (merchant !== 'undefined') {
        window.location.href = merchant.url;
      } else {
        window.location.href = '/';
      }
    }
  };

  return (
    <div id="content" className="has-text-centered">
      <div className="is-size-4 has-text-weight-semibold">
        We're sorry, but this order exceeds your current credit limit
      </div>

      <Error />

      <p className="my-5">
        Interested in raising your limit with Credit Key? Click the button or chat widget below,
        or contact us at {supportPhone} or <a href="mailto: support@creditkey.com">support@creditkey.com</a> to find out how.
      </p>

      {cart &&
        orderMessages.map((m, idx) => {
          return (
            <p className="mb-5" key={idx}>
              {m}
            </p>
          );
        })}

      <Support />

      <ReturnToMerchant 
        merchant={merchant}
        redirect={redirect}
      />
    </div>
  );
}
